import React from 'react';
import RenderGameIcon from '../RenderImg/renderGameIcon';
import BubbleCommon from '../BubbleCommon';
import './index.scss';

export default function GameItem(props: any) {
  const { tipsMap, gameInfo, handleGameClick, children } = props;

  function getGameEntityName() {
    let element = (
      <div
        className="dbo-gameitem-name"
        onClick={(e) => {
          handleGameClick?.(e);
        }}
      >
        {gameInfo?.entity_name}
      </div>
    );

    if (tipsMap) {
      return <BubbleCommon showIcon={false} placement='top' tipsMap={tipsMap}>{element}</BubbleCommon>;
    }

    return element;
  }

  return (
    <div className="dbo-gameitem">
      <RenderGameIcon
        gameInfo={gameInfo}
        className="dbo-gameitem-avatar"
      ></RenderGameIcon>

      <div className="dbo-gameitem-info">
        {getGameEntityName()}
        {children}
      </div>
    </div>
  );
}
